<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog" role="document">
			<div v-if="data" class="modal-content">
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4 v-if="data.payment_method" class="modal-title">Seleccionar cuenta de {{ data.payment_method.name }}</h4>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<template v-if="data.payment_method">
								<template v-if="data.payment_method.collection_accounts">
									<template v-if="data.payment_method.collection_accounts.length">
										<select @change="collectionAccountSelected" v-model="collection_account_id" class="form-control">
											<option :disabled="account.status_id == 1" v-for="account in data.payment_method.collection_accounts" :value="account.id">
												{{ account.name }}
											</option>
										</select>
									</template>
								</template>
							</template>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'

	export default {
		props: ['user', 'isAuth', 'data'],
		components: {
		},
		data () {
			return {
				modal: {
					selector: 'modal-collection-accounts'
				},

				loading: false,
				collection_account_id: null,
			}
		},
		methods: {
			open() {
				if(this.data) {
					this.collection_account_id = this.data.collection_account_id
				}
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			collectionAccountSelected(el) {
				var select = el.currentTarget
				select.setAttribute('disabled', true)
				this.loading = true
				this.$http.get('admin/management/invoices/' + this.data.id + '/change/collection/account/' + this.collection_account_id)
				.then(response => {
					this.loading = false
					select.removeAttribute('disabled')
					this.$emit('reload')
					this.close()
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
				}).catch(response => {
					this.loading = false
					select.removeAttribute('disabled')
					if(response.status == 409) {
						swal({
							title: response.statusText,
							text: response.body,
							type: 'warning',
						})
					}
					this.$emit('reload')
				})
			}
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/invoices/views/CollectionAccounts.vue